import { render, staticRenderFns } from "./round.vue?vue&type=template&id=3897b456&scoped=true&"
import script from "./round.vue?vue&type=script&lang=js&"
export * from "./round.vue?vue&type=script&lang=js&"
import style0 from "./round.vue?vue&type=style&index=0&id=3897b456&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3897b456",
  null
  
)

export default component.exports